import {useEffect} from 'react'
import {UsagesModalHeader} from './UsagesModalHeader'
import {UsagesModalFormWrapper} from './UsagesModalFormWrapper'

const UsagesModal = ({
  promo,
  usages,
  onClose
}) => {
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className={`modal-dialog modal-dialog-centered mw-700px`}>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <UsagesModalHeader promo={promo} onClose={onClose} />
            {/* begin::Modal body */}
            <div className={`modal-body scroll-y mx-5 mx-xl-5 my-7 `}>
              <UsagesModalFormWrapper usages={usages} onClose={onClose} />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export {UsagesModal}
